/**
 * ANQ.Rate.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface CreateRateDto {
    id?: string;
    merchantName: string | undefined;
    merchantId: string |undefined;
    rateName: string;
    currency: number;
    createdOn?: Date;
    effectiveDate: Date;
    terminationDate: Date;
    isDedicated?: boolean;
    isDeleted?: boolean;
    isExpired?: boolean;
    isExtended?: boolean;
}
